import { useEffect, useState } from 'react'

const TYPING_PHRASES = [
  'Checking SOPs',
  'Reviewing protocols',
  'Consulting the playbook',
  'Scanning procedures',
  'Cross-referencing SOPs',
  'Pulling up guidelines',
  'Consulting The Hive',
]

const PHRASE_ROTATE_MIN_MS = 2000
const PHRASE_ROTATE_RANGE_MS = 1000

const pickRandom = (current: string): string => {
  const pool = TYPING_PHRASES.filter((p) => p !== current)
  return pool[Math.floor(Math.random() * pool.length)] ?? current
}

/**
 * Rotates through typing phrases randomly every 2-3s.
 * Returns the current phrase string.
 */
export const useTypingPhrase = () => {
  const [phrase, setPhrase] = useState(
    () =>
      TYPING_PHRASES[Math.floor(Math.random() * TYPING_PHRASES.length)] ??
      TYPING_PHRASES[0]!
  )

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>

    const rotate = () => {
      setPhrase((prev) => pickRandom(prev))
      timer = setTimeout(
        rotate,
        PHRASE_ROTATE_MIN_MS + Math.random() * PHRASE_ROTATE_RANGE_MS
      )
    }

    timer = setTimeout(
      rotate,
      PHRASE_ROTATE_MIN_MS + Math.random() * PHRASE_ROTATE_RANGE_MS
    )
    return () => clearTimeout(timer)
  }, [])

  return phrase
}
